import { render, staticRenderFns } from "./ButtonAddQuestion.vue?vue&type=template&id=2c38fa28&scoped=true&"
import script from "./ButtonAddQuestion.vue?vue&type=script&lang=js&"
export * from "./ButtonAddQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAddQuestion.vue?vue&type=style&index=0&id=2c38fa28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38fa28",
  null
  
)

export default component.exports